import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { UserIdentityConflictContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getNoDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';
import { UserIdentityConflicts } from '../services/resources/UserIdentityConflicts';

export const UserIdentityConflictDefinition: ExplorableItemDefinition = {
  itemType: 'userIdentityConflict',
  singularName: () => Messages.identityMigration_ConflictsSingularName(),
  pluralName: () => Messages.identityMigration_ConflictsPluralName(),
  emptyStateMessage: () => Messages.identityMigration_ConflictsEmptyStateMessage(),
  contentFilterKeys: UserIdentityConflictContentType.filterKeys,
  filterClause: ServerFilterClauses.ContentType(['userIdentityConflict']) as ContentTypeFilterClause,
  defaultFilters: getNoDefaultFilters,
  supportedDisplayModes: ['list'],
  cardComponent: GenericCard,
  listViewIconType: null,
  getContentInfo: () => {
  },
  getBasicQuery: () => {
    return UserIdentityConflicts.all();
  },
};
